import {IRSCategory} from './transactions.types';

export const IRSCatgoriesRequireTypeOfExpense = [
  IRSCategory.HomeImprovement,
  IRSCategory.HomeInsurance,
  IRSCategory.MortgageInsurance,
  IRSCategory.Mortgage,
  IRSCategory.Rent,
];
